import Empty from '@/assets/placeholders/empty.png';

import { CoinChartColorType, WhiteLabelTheme } from '../types';

import AppLogoIcon from './assets/app-logo.svg';
import CardLogo from './assets/card-logo.svg';
import SettingsBackgroundIllustration from './assets/ill_settings_decoration.svg';
import manageProfileBanner from './assets/ill_settings_decoration.svg';
import LoginBackground from './assets/login_bg_illustration.svg';
import LogoIcon from './assets/logo.svg';
import SmallLogoIcon from './assets/minify-logo.svg';
import QrCodeLogo from './assets/qrCodeLogo.svg';
import ReimburseMeSidebar from './assets/reimburseMeSidebar.svg';
import SidebarLogoIcon from './assets/sidebar-logo.svg';
import SidebarSmallLogoIcon from './assets/sidebar-minify-logo.svg';
import SignInLogo from './assets/signIn-logo.svg';
import VerificationBanner from './assets/verification_bg_illustration.svg';
import BannerImage from './assets/welcome_banner_illustration.svg';

const buttonColors = {
  onDarkButtonPrimary: '#2287B2',
  onDarkButtonPrimaryHover: '#1D7499',
  onDarkButtonPrimaryActive: '#165773',
  onDarkButtonPrimaryPressed: '#165773',
  onDarkButtonPrimaryDisabled: '#0E5370',

  onDarkButtonSecondaryHoverBorder: '#2287B2',
  onDarkButtonSecondaryActiveBorder: '#1A6E91',
  onDarkButtonSecondaryDisabledBorder: '#065070',
  onDarkButtonSecondaryDisabled: '#003A53',
  onDarkButtonSecondaryHover: '#105A79',

  onDarkModuleBackground: '#0D496E',
  onDarkBackground: '#003F66',

  onDarkIconDisabled: '#747474',
  onDarkIconAccent: '#2BA2D4',
  onDarkText: '#747474',

  buttonPrimary: '#0076A8',
  buttonPrimaryHover: '#006894',
  buttonPrimaryActive: '#004461',
  buttonPrimaryPressed: '#006894',
  buttonPrimaryDisabled: '#EAECF9',

  buttonSecondaryHoverBorder: '#0076A8',
  buttonSecondaryActiveBorder: '#004461',
  buttonSecondaryDisabledBorder: '#EAECF9',
  buttonSecondaryDisabled: '#FFFFFF',
  buttonSecondaryHover: '#DAEBF2',

  buttonTertiaryHover: '#DAEBF2',
  buttonTertiaryPressed: '#B1D7E7',
  buttonTertiaryDisabled: '#E8E9EF',
  buttonSecondaryContainer: '#EAECF9',
};
const navigationColors = {
  navigationBackground: '#004976',
  navigationBorder: '#225778',
  navigationAccent: '#F20D32',
  navigationAccent2: '#F20D32',
  navigationTextDefault: '#FFFFFF',
  navigationTextAccent: '#FFFFFF',
  navigationIconDefault: '#FFFFFF',
  navigationIconAccent: '#FFFFFF',
  navigationAccentHover: '#075D93',
  navigationAccentActive: '#077BC2',
};
const backgroundColors = {
  background1: '#004976',
  background2: '#004976',
  background3: '#000000',

  border: '#BABABC',
  border1: '#DCDCDC',
  border2: '#EAEAEA',
  module: '#FBFAFA',
  canvas: '#FFFFFF',
  stressContainer: '#4F5557',
  accentActive: '#0078C0',
  accentBorder: '#BABABC',
  accentContainer: '#F5F7FF',

  popupBg2: '#0F16210D',
  legend: '#C2E0F2',
};

const baseColors = {
  ...buttonColors,
  ...navigationColors,
  ...backgroundColors,
  textTitle: '#0F1621',
  textBody: '#0F1621',
  textActive: '#004975',
  textActiveHover: '#003657',

  ancor: '#004975',
  ancorHover: '#003657',
  activeButtonText: '#004975',
  paginationActiveItem: '#0078C0',
  buttonText: '#FFFFFF',
  sidebarDelimiter: '#BFBFBF',

  tableHeader: '#0F1621',

  textSecondary: '#6B7485',
  textDisabled: '#9BA3B3',
  textOnColor: '#FFFFFF',
  textAccent: '#004975',
  textAccentHover: '#003657',
  textAccentActive: '#00263D',

  iconPrimary: '#0F1621',
  iconActive: '#0F1621',
  iconActiveHover: '#0F1621',

  iconSecondary: '#6B7485',
  iconOnColor: '#FFFFFF',
  iconAccent: '#004975',
  iconAccentHover: '#003657',
  iconAccentActive: '#00263D',
  iconDisabled: '#9BA3B3',

  success: '#19B269',
  successBorder: '#B8E7D1',
  successContainer: '#E8F7F0',

  warning: '#F9C134',
  warningBorder: '#FDECC0',
  warningContainer: '#FEF9EB',

  danger: '#E72626',
  dangerBorder: '#F8BCBC',
  dangerContainer: '#FDE9E9',
  dangerHover: '#A61C18',
  dangerActive: '#66120A',

  info: '#176AF6',
  infoBorder: '#B7D1FC',
  infoContainer: '#E8F0FE',

  transactionDental: '#176AF6',
  transactionVision: '#481A54',
  transactionMedical: '#00C3B3',
  transactionOther: '#FF9D0A',
  transactionParking: '#323D9B',
  transactionTransit: '#9BBF84',
  transactionAdoption: '#0F7970',
  transactionDependentCare: '#CC3381',
  transactionPharmacy: '#D83B00',
  transactionLifestyle: '#D3375C',
  transactionPremium: '#3628D1',
  transactionTravel: '#F26B31',
  transactionWellness: '#9B31F2',
  transactionPlanSpecific: '#00B5EE',
  refund: '#588C0E',
  transactionDefault: '#5E697E',
  claimTransferInternal: '#E5E9F0',
  nonClaimIcon: '#151F6D',
  nonClaimBg: '#E5E9F0',

  planTypeHSA: '#2EA12B',
  planTypeHCFSA: '#FA802A',
  planTypeDCAP: '#CC3381',
  planTypeHRA: '#134E8F',
  planTypeCommuterTransit: '#9BBF84',
  planTypeCommuterParking: '#323D9B',
  planTypeAdoption: '#0F7970',
  planTypeLifestyle: '#D3375C',
  planTypeSpecialty: '#00B5EE',
  planTypeTravel: '#F26B31',
  planTypeRx: '#7909AD',
  planTypeDental: '#176AF6',
  planTypeVision: '#481A54',
  planTypeMedical: '#00C3B3',

  lockedNull: '#000000',
  processingPending: '#F9C134',
  needsHelp: '#FF9D0A',
  paidActiveComplete: '#19B269',
  partiallyPaid: '#B9CC29',
  // waitingForFunds
  waitingForFunds: '#8EB2A1',
  //
  deniedErrorExpired: '#E72626',
  uploading: '#9BA3B3',
  uploadedApproved: '#E8F0FE',
  loa: '#00B5EE',
  retirement: '#CE8258',
  future: '#7909AD',

  missingDetail: '#FB6D2A',
  missingContainer: '#FFF3EE',
  missingBorder: '#FEDACA',

  investmentsfuture: '#7909AD',
  investmentsFund1: '#3F68FF',
  investmentsFund2: '#10D8B9',
  investmentsFund3: '#FB5C20',
  investmentsFund4: '#FC990F',
  investmentsFund5: '#FDD137',
  investmentsFund6: '#BCD1EF',
  investmentsFund7: '#323D9B',
  investmentsFund8: '#F3C626',
  investmentsFund9: '#A528C6',
  investmentsFund10: '#0C95D0',
  investmentsFund11: '#619C00',
  investmentsFund12: '#CC3381',
  investmentBackground: '#004976',
  profitContainer: '#00FF9314',
  lossContainer: '#EF235D14',
  chart: '#18ABC4',
  coinChart: ['#B8E7D1', '#E8F7F0', '#C3F5DD', '#E8F7F0', '#E8F7F0'] as CoinChartColorType,

  // new
  partner: '#D83B00',
  distributor: '#904D27',
  employer: '#174FBC',
  subsidiary: '#0F7970',
  subgroup: '#481A54',
  claimProcessor: '#176AF6',
  employee: '#0CAD09',
  dependent: '#5E1696',
  noAssignee: '#B8BFCC',

  claimParticipant: '#CC3381',
  claimSystem: '#18A0FB',
  claimCardProcessor: '#19B269',

  uploadLinkBackground: '#0076A8',
};
export default {
  title: 'Proficient',
  loginIconWidth: 432,
  loginIconHeight: 88,

  IOSAppStoreLink: 'https://apps.apple.com/us/app/proficient-one/id6758155005',
  androidAppStoreLink: 'https://play.google.com/store/apps/details?id=net.proficientbenefits.app',

  mobileAppIconWidth: 50,
  mobileAppIconHeight: 50,
  mobileAppIcon: AppLogoIcon,
  mobileAppTitle: 'Proficient ONE',

  loginScreenTitle:
    'The only automated, AI-powered, and ultra-reliable solution for today’s consumer benefits.',
  colors: {
    ...baseColors,
    loginTitleColor: '#FFFFFF',
    //
    popup: 'rgba(0, 0, 0, 0.5)',
    popup2: 'rgba(15, 22, 33, 0.05)',
    fade1: 'linear-gradient(360deg, #F7F3F1 0%, rgba(255, 255, 255, 0) 100%)',
    fade2: 'linear-gradient(180deg, #FAFAFA 0%, #F4F4F4 100%)',
  },
  logo: LogoIcon,
  minifyLogo: SmallLogoIcon,
  font: "'MuseoSansCyrl', sans-serif",
  titleFont: "'MuseoSansCyrl', sans-serif",
  tetriaryAccentButton: true,
  images: {
    settingsIllustration: SettingsBackgroundIllustration,
    banner: BannerImage,
    cardBackground: Empty,
    loginBackground: LoginBackground,
    cardLogo: CardLogo,
    sidebarLogo: SidebarLogoIcon,
    sidebarMinifyLogo: SidebarSmallLogoIcon,
    qrCodeLogo: QrCodeLogo,
    manageProfileBannerBackground: manageProfileBanner,
    investmentsBannerRight: ' ',
    reimburseMeSidebar: ReimburseMeSidebar,
    signUpSidebar: ReimburseMeSidebar,
    verificationBackground: VerificationBanner,
    signInLogo: SignInLogo,
  },
  fonts: {
    sidebarWeight: 500,
    sidebarFontSize: '14px',
    reimbursementWeight: 500,
    sizes: {
      small: {
        size: '12px',
        height: '16px',
        maxWidth: '336px',
      },
      '3xl': {
        size: '30px',
        height: '40px',
        maxWidth: '1008px',
      },
      '2xl': {
        size: '24px',
        height: '30px',
        maxWidth: '816px',
      },
    },
  },
  rounds: {
    largeRound: '0px',
    moduleRound: '0px',
    container1Round: '0px',
    container2Round: '0px',
    container3Round: '0px',
    checkboxRound: '0px',
    navigationButtonRound: '0px',
    fieldRound: '0px',
    button1Round: '50px',
    button2Round: '50px',
    dropdownItemRound: '0px',
    snackbarRound: '0px',
    smallRound: '0px',
    tabRound: '0px',
  },

  shadows: {
    default: '0px 1px 7px rgba(0, 0, 0, 0.04);',
    hover: '0px 3px 10px rgba(0, 0, 0, 0.1);',
    active: '0px 8px 25px rgba(0, 73, 118, 0.25);',
    highlighted: '0px 6px 16px rgba(0, 73, 118, 0.5);',
  },
  favicon: '/proficient/favicon.ico',
  favicon16: '/proficient/favicon-16x16.png',
  favicon32: '/proficient/favicon-32x32.png',
  faviconAppleTouch: '/proficient/apple-touch-icon-fidelity.png',
} as WhiteLabelTheme;
